"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_USER = void 0;
var client_1 = require("@apollo/client");
exports.ADD_USER = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation AddUser($input: AddUserInput!) {\n    addUser(input: $input) {\n      user {\n\t\t\t\tfirstName\n        lastName\n      }\n    }\n  }\n"], ["\n  mutation AddUser($input: AddUserInput!) {\n    addUser(input: $input) {\n      user {\n\t\t\t\tfirstName\n        lastName\n      }\n    }\n  }\n"])));
var templateObject_1;
